import { Link } from "gatsby";
import React from "react";
const Breadcrumbs = ({
  item
}) => {
  return (
    <>
      <li><Link to={item.slug}>{item.name}</Link></li>
    </>
  )
}

export default Breadcrumbs;